export default __webpack_public_path__ + "static/media/logo.1e5fc1ab.svg";